import React, { useState } from "react";
import Flatpickr from "react-flatpickr";

function DateRangeFilter({ startDate, endDate, labels, onChange, title, description, rangeLabel, summaryItems = [], entityFilters = null }) {
  const [activePreset, setActivePreset] = useState(null);

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const applyPreset = (preset) => {
    const today = new Date();
    let startVal, endVal;

    switch (preset) {
      case "today":
        startVal = endVal = formatDate(today);
        break;
      case "thisWeek": {
        const dayOfWeek = today.getDay();
        const monday = new Date(today);
        monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7));
        startVal = formatDate(monday);
        endVal = formatDate(today);
        break;
      }
      case "thisMonth":
        startVal = formatDate(new Date(today.getFullYear(), today.getMonth(), 1));
        endVal = formatDate(today);
        break;
      case "last3Months": {
        const threeMonthsAgo = new Date(today);
        threeMonthsAgo.setMonth(today.getMonth() - 3);
        startVal = formatDate(threeMonthsAgo);
        endVal = formatDate(today);
        break;
      }
      default:
        return;
    }

    setActivePreset(preset);
    onChange(startVal, endVal);
  };

  const handleCustomDate = (field, dates) => {
    if (!dates.length) return;
    setActivePreset(null);
    const newDate = formatDate(dates[0]);
    if (field === "start") {
      onChange(newDate, endDate);
    } else {
      onChange(startDate, newDate);
    }
  };

  const presets = [
    { key: "today", label: labels.today },
    { key: "thisWeek", label: labels.thisWeek },
    { key: "thisMonth", label: labels.thisMonth },
    { key: "last3Months", label: labels.last3Months },
  ];

  return (
    <div className="card analytics-filter-bar mb-4">
      <div className="card-body">
        {(title || description || rangeLabel) && (
          <div className="analytics-filter-bar__head">
            <div className="analytics-filter-bar__copy">
              {title && <h6 className="analytics-filter-bar__title">{title}</h6>}
              {description && <p className="analytics-filter-bar__description">{description}</p>}
            </div>
            {rangeLabel && (
              <span className="analytics-filter-bar__range">
                <i className="zmdi zmdi-calendar-note" />
                <span>{rangeLabel}</span>
              </span>
            )}
          </div>
        )}

        {summaryItems.length > 0 && (
          <div className="analytics-filter-bar__summary">
            {summaryItems.map((item) => (
              <div key={item.label} className="analytics-filter-bar__summary-item">
                <span className="analytics-filter-bar__summary-label">{item.label}</span>
                <strong className="analytics-filter-bar__summary-value">{item.value}</strong>
                {item.hint && <small className="analytics-filter-bar__summary-hint">{item.hint}</small>}
              </div>
            ))}
          </div>
        )}

        {entityFilters && <div className="analytics-filter-bar__entities">{entityFilters}</div>}

        <div className="analytics-filter-bar__controls">
          <div className="analytics-filter-bar__presets">
            {presets.map((p) => (
              <button
                key={p.key}
                type="button"
                className={`btn btn-sm analytics-filter-bar__preset ${activePreset === p.key ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => applyPreset(p.key)}
              >
                {p.label}
              </button>
            ))}
          </div>

          <div className="row analytics-filter-bar__fields">
            <div className="col-md-6">
              <div className="form-group analytics-filter-bar__field">
                <label className="analytics-filter-bar__field-label">{labels.startDate}</label>
                <div className="analytics-filter-bar__field-control">
                  <i className="zmdi zmdi-calendar-note analytics-filter-bar__field-icon" />
                  <Flatpickr
                    value={startDate}
                    options={{ dateFormat: "Y-m-d", maxDate: endDate, disableMobile: true }}
                    onChange={(dates) => handleCustomDate("start", dates)}
                    className="form-control form-control-sm analytics-filter-bar__input"
                    placeholder={labels.startDate}
                  />
                  <i className="form-group__bar" />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group analytics-filter-bar__field">
                <label className="analytics-filter-bar__field-label">{labels.endDate}</label>
                <div className="analytics-filter-bar__field-control">
                  <i className="zmdi zmdi-calendar-note analytics-filter-bar__field-icon" />
                  <Flatpickr
                    value={endDate}
                    options={{ dateFormat: "Y-m-d", minDate: startDate, disableMobile: true }}
                    onChange={(dates) => handleCustomDate("end", dates)}
                    className="form-control form-control-sm analytics-filter-bar__input"
                    placeholder={labels.endDate}
                  />
                  <i className="form-group__bar" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DateRangeFilter;
